module.exports = __webpack_public_path__ + "img/icon-contact.d5601796.svg";